import { requests } from 'api';
import { InterventionLanguage } from './types';

const apiBaseUrl = '/api/interventionLanguages';

export const InterventionLanguagesApi = {
  getAll: (): Promise<InterventionLanguage[]> => requests.get(apiBaseUrl),
};
